import React, { useState, useEffect } from 'react'
import { Autocomplete, FormControl, Select, TextField } from '@mui/material'
import styled from 'styled-components'

const Controls = ({
  municipalityNames,
  triggerSearch,
  triggerPropertyTypeChange,
  triggerRoomChange,
}: {
  municipalityNames: string[]
  triggerSearch: (search: string) => void
  triggerPropertyTypeChange: (propertyType: string) => void
  triggerRoomChange: (room: string) => void
}) => {
  const [propertyType, setPropertyType] = useState<'maison' | 'appartement'>(
    'maison'
  )
  const defaultPropertyType = 'maison'

  // Search box
  const [inputSearchOptions, setInputSearchOptions] = useState<string[]>([''])
  const handleSearchInput = (e: any, newInputValue: string) => {
    if (inputSearchOptions.includes(newInputValue)) {
      triggerSearch(newInputValue)
    }
  }

  // Type of property: house, apartment
  const handlePropertyTypeChange = (e: any) => {
    setPropertyType(e.target.value)
    triggerPropertyTypeChange(e.target.value)
  }

  // Number of rooms
  const handleRoomChange = (e: any) => {
    triggerRoomChange(e.target.value)
  }
  const rooms =
    propertyType === 'maison'
      ? ['', '3', '4', '5', '6']
      : ['', '1', '2', '3', '4']

  useEffect(() => {
    setInputSearchOptions(
      [''].concat(
        municipalityNames.sort(function (a, b) {
          return a.localeCompare(b)
        })
      )
    )
  }, [municipalityNames])

  return (
    <Container>
      <Block>
        <FormControl fullWidth>
          <Autocomplete
            disablePortal
            options={inputSearchOptions}
            renderInput={(params) => (
              <TextField {...params} label='Chercher une commune…' />
            )}
            onInputChange={handleSearchInput}
            blurOnSelect
            defaultValue={''}
          />
        </FormControl>
      </Block>
      <Block>
        <FormControl fullWidth>
          <Select
            native
            defaultValue={defaultPropertyType}
            onChange={handlePropertyTypeChange}
          >
            <option value='maison'>Maisons</option>
            <option value='appartement'>Appartements</option>
          </Select>
        </FormControl>
      </Block>
      <Block>
        <FormControl fullWidth>
          <Select native defaultValue={''} onChange={handleRoomChange}>
            {rooms.map((room) => (
              <option value={room} key={`room_${room}`}>
                {room} {room !== '' ? 'pièces' : 'Nombre de pièces…'}
              </option>
            ))}
          </Select>
        </FormControl>
      </Block>
    </Container>
  )
}
const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1ch;
  margin-bottom: 1ch;
`
const Block = styled.div`
  flex-grow: 1;
  &:first-of-type {
    flex-grow: 4;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`
export default Controls
